import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  paper: {
    fontSize: '12px !important',    
  }
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [saveBtnLoading, setSaveBtnLoading] = React.useState(false);

  const [otpNumberError, setOtpNumberError] = React.useState(false);
  const [otpNumber, setOtpNumber] = React.useState("");
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  // function handleClassName(clsName){    
  //   if(clsName && props.classes.length>0){
  //     for(let i=0; i<props.classes.length; i++){
  //       if(props.classes[i].className===clsName){
  //         setCourseId(props.classes[i].courseId);
  //         setCourseTitle(props.classes[i].courseTitle);
  //         setOrganisationId(props.classes[i].organisationId);
  //         setClassName(props.classes[i].className);
  //       }
  //     }
  //   }
  // }


	function saveData(){

    if(!otpNumber || (otpNumber && otpNumber.length<1)){
        setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage("Enter OTP.");	
        setOtpNumberError(true);
				return false;
    }

		if(otpNumber){ 
      setSaveBtnLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
          'studentId': etlStudentObj.studentId,
					'token': etlStudentObj.token,
				}
			}; 

      const data = new FormData(); 
      data.append('email', props.emailId);
      data.append('token', props.token);
			data.append('otpNumber', otpNumber);
      
			axios.post(API_URL+'/student-profile-email-update', data, axiosHeader)
			.then((response) => {
        setSaveBtnLoading(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          etlStudentObj.emailId=props.emailId;
          localStorage.setItem("etlStudentObj", JSON.stringify(etlStudentObj));
          localStorage.setItem("etlStudentEmailId", props.emailId);
          setSeverityAlert("success");
          setShowAlert(true);
          setAlertMessage("Email has been saved successfully.");
          if(props.redirectToPayment>0){
            props.continueToPayment(props.emailId);
            setOpen(false);
          }else{
            window.location.reload();
          }
          return false; 
        }else if(response.data.responseTxt==="InvalidOTP"){
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Invalid OTP");
            return false;        
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Error somewhere, Try after sometime.");			
					return false;
				}
			})
			.catch((error) => {
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

  React.useEffect(() => {
    setOtpNumber("");
    setOtpNumberError(false);
    setSaveBtnLoading(false);
	}, [open]);
  
  function numberOnly(event){
		if (!/[0-9]/.test(event.key)) {
			event.preventDefault();
		} 
	}

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>Verify OTP</h3></div>

                  <p>
                           We have sent OTP to {props.emailId}, Check your email.
                            <TextField 
                              label="OTP Number"
                              placeholder='Enter your OTP'
                              onChange={event => setOtpNumber(event.target.value)} 
                              onKeyPress={(event)=>{numberOnly(event)}}
                              value={otpNumber} 
                              sx={{width:'99%',fontSize: 10}} 
                              variant="outlined"         
                              error={otpNumberError}       
                              inputProps={{ maxLength: 6 }}              
                              />

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Change Email ID</Button>
					    	          
                          {saveBtnLoading?
                            <LoadingButton size="small" loading={saveBtnLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#f7772e',color:'#FFFFFF'}} variant="contained" >Wait</LoadingButton>
                          :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Verify OTP</Button>
                          }

								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;